<template>
    <div class="audioInfoWrapper">
        <div class="title" :style="{background: `url(${list.cover}) center center/120% no-repeat`}">
            <div class="titleContent">
                <div class="titleImg">
                    <img :src="list.cover" alt="">
                </div>
                <div class="source">来源：{{list.source}}</div>
            </div>
        </div>

        <div class="content">
            <div v-for="(it, ix) in columns" class="columns" @click="handleAudioDetail(it.name, ix)" :key="`columns-${ix}`">
                <div class="columnsTitle">{{it.name}}</div>
                <div class="columnsInfo">
                    <div class="time"><img src="~@/assets/img/clock.png" alt=""></div>
                    <div class="columnsDuration">{{formatDuration(it.duration)}}</div>
                    <div class="columnsPublish">{{it.publish.split(' ')[0]}}</div>
                </div>
            </div>
            <div v-if="isLoading" class="over">
                加载中...
<!--                <img src="~@/assets/img/loading1.gif" alt="">-->
            </div>
            <div v-if="isOver && !isLoading" class="over">
                没有更多了~
            </div>
        </div>
    </div>
</template>

<script>
    import {mapState, mapMutations, mapActions} from 'vuex'
    import {audioDetailTemplate, formatAudioTime} from '@/utils/utils'

    export default {
        name: "AudioInfo",
        props: {
            list: {
                type: Object,
                default: ()=> {}
            },
            refresh: {
                type: Boolean,
                default: false
            }
        },
        data(){
            return {
                page: 1,
                columns: [],
                isLoading: false,
                isOver: false,
                totalColumns: [],
            }
        },
        created() {
            this.columns = this.list.columns
            // 获得该专辑下所有的栏目
            this.queryAudioList({payload: {id: this.readNewsId, page: 1, pageSize: this.list.hasNews}}).then((res)=>{
                let columns =  res[1].content.list
                if(columns.length !== 0){
                    this.totalColumns.push(...columns)
                }
            })
        },
        watch: {
            refresh(value){
                if(value){
                    this.isLoading = true
                    this.queryAudioList({payload: {id: this.readNewsId, page: this.page + 1, pageSize: 10}}).then((res)=>{
                        this.isLoading = false
                        this.page += 1
                        let columns =  res[1].content.list;
                        if(columns.length !== 0){
                            this.columns.push(...columns)
                        } else {
                            this.isOver = true
                        }

                    })
                }
            },
            list(value){
                this.page = 1
                this.columns = value.columns
                this.totalColumns = []
                // 获得该专辑下所有的栏目
                this.queryAudioList({payload: {id: this.readNewsId, page: 1, pageSize: value.hasNews}}).then((res)=>{
                    let columns =  res[1].content.list
                    if(columns.length !== 0){
                        this.totalColumns.push(...columns)
                    }
                })
            }
        },
        computed: {
          ...mapState(["readNewsId"])
        },
        methods: {
            ...mapMutations('audio',["setAudioList", "setAudioCurrentIndex", "setAudioCurrentTime"]),
            ...mapMutations(["contactDisData", "setToastShow"]),
            ...mapActions(["queryAudioList", "asyncEnterAudio"]),
            handleAudioDetail(name, index){
                let audioTemplate = audioDetailTemplate(this.totalColumns, name)
                this.setToastShow(false)
                this.setAudioCurrentIndex(index)
                this.setAudioCurrentTime(0)
                this.asyncEnterAudio()
                this.contactDisData([{content: {right: true, tips: "音频详情"}}])
                this.contactDisData(audioTemplate);
            },
            formatDuration(time){
                if(time){
                    const [minute, second='0'] = time.split('.')
                    time = Number(minute) * 60 + Number(second)
                    return formatAudioTime(time)
                }
            }
        }
    }
</script>

<style scoped lang="less">
    .audioInfoWrapper{
        .title{
            width: 100%;
            height: 4.22rem;
            border-radius: .5rem .5rem 0 0;
            background-color: rgb(9, 23, 79) !important;
            position: absolute;
            left: 0;
            right: 0;
            z-index: 10;
        }
        .titleContent{
            width: 100%;
            /*position: absolute;*/
            height: 4.27rem;
            /*top: -.02rem;*/
            /*left: 0;*/
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            background-color: rgba(9,23,79, .7);
            border-radius: .5rem .5rem 0 0;
            z-index: 11;
            .titleImg{
                width: 2.13rem;
                border-radius: 0.16rem;
                height: auto;
                background-color: rgba(37, 88, 246, .2);
                img{
                    border-radius: 0.16rem;
                    display: block;
                }
            }
            .source{
                margin-top: .43rem;
                color: #fff;
                font-size: 0.43rem;
            }
        }
        .content{
            position: relative;
            top: 4.27rem;
            min-height: 11rem;
            overflow-y: auto;
            .columns{
                margin: 0 0.43rem;
                padding: .43rem 0;
                border-bottom: 0.03rem solid rgb(230, 230, 230);
                .columnsTitle{
                    font-size: 0.48rem;
                    font-family: PingFangSC-Medium, PingFang SC;
                    font-weight: 600;
                    color: #171E32;
                    line-height: 0.69rem;
                }
                .columnsInfo{
                    font-size: 0.32rem;
                    color: #999999;
                    line-height: 0.32rem;
                    margin-top: .45rem;
                    .time{
                        display: inline-block;
                        width: .32rem;
                        height: .32rem;
                        top: .02rem;
                        position: relative;

                    }
                    .columnsDuration{
                        display: inline-block;
                        margin-left: .16rem;
                    }
                    .columnsPublish{
                        display: inline-block;
                        margin-left: .56rem;
                    }
                }

            }
            .loading{
                margin: 0 auto;
                width: 3rem;
            }
            .over{
                font-size: .32rem;
                color: #999999;
                text-align: center;
                line-height: 1rem;
            }
        }
    }
</style>
